import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { IconAnchor } from '../../../../common/icons/cdl/Anchor';
import { theme } from '../../../../common/ui/theme';

interface TimelineCircleStyledProps {
    isCurrentPort: boolean;
}

const StyledTimelineCircle = styled.div<TimelineCircleStyledProps>`
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    ${({ isCurrentPort }) =>
        isCurrentPort
            ? `
        background-color: ${theme.colors.accent.emphasis};
        border: 1px solid ${theme.colors.accent.foreground};
        color: ${theme.colors.foreground.onEmphasis};
    `
            : `
        background-color: ${theme.colors.accent.background};
        border: 1px solid ${theme.colors.border.default};
        color: ${theme.colors.foreground.muted};
    `}
`;

interface TimelineCircleProps {
    isCurrentPort: boolean;
    displayNumber: number | null;
}

export const TimelineCircle = ({ isCurrentPort, displayNumber }: TimelineCircleProps) => {
    return (
        <StyledTimelineCircle isCurrentPort={isCurrentPort}>
            {isCurrentPort ? (
                <IconAnchor width={14} height={14} />
            ) : (
                <Text variant="extraSmall" fontWeight={600}>
                    {displayNumber}
                </Text>
            )}
        </StyledTimelineCircle>
    );
};
